import UtilSP from 'SATPROF_UTILS/UtilSP';
import Complex from 'SATPROF_UTILS/Complex';
import Waveform1 from 'SATPROF_UTILS/Waveform1';
import Waveform2 from './Waveform2';

export default class SigProc {
	/*
	Signal processing library.
	Adapted for TypeScript RLB 9/2020
	Added fftInverseSwap  RB 3/10/08
	
	fftCore(x:Array, y:Array, inv:boolean)     Does and FFT or inv FFT in place.  Length MUST BE a power of 2.
	fftSwap( d:Array ):Array
	fftInverseSwap( d:Array ):Array
	nextMul( arraySize:number ):number  Next hightest multiple of 2
	totalPowerW( S, Z0 );		Total power in the voltage spectrum assuming real impedance R0

	rescaleSpectrum( S_local, Fc_local, Fstep_local, N_local, Fc_global, Fstep_global, N_global); 
		// Rescales and interpolates S_local to a global scale, center freq, and freq step.
		// Returns S_global (complex spectrum array).
	
	listSpectrum_ifo( S, fs ) // Lists spectrum by frequency.  S = complex spectrum in freq order, fs = frequency step
	fftI2F_fto( j, N, fs ) // Returns the frequency of a given index in FFT order
	fftF2I_fto( f, N, fs ) // Returns the index of a given frequency in FFT order
	fftI2F_ifo( k, N, fs ) // Returns the frequency of a given index in increasing freq order
	fftF2I_ifo( f, N, fs ) // Returns the index of a given frequency in increasing freq order
	
     In Increasing-Frequency Order:
	    f		     k
	  -------	  --------
	-fmax+fstep		0
		0			N/2 -1
	   fmax			N-1

	 In FFT order:
	    f		     k
	  -------	  --------
		0			0
		fmax		N/2
	-fmax+fstep		N/2+1
	  -fstep		N-1
	  
	  where fmax = (N/2) . fstep	( fstep = fmax * 2 / N)

	N = number of samples
	Tmax = N . Tstep.  Note last point is at N-1 i.e. Tmax-Tstep
	Fmax = 1/ (2 * Tstep)
	Fmax = (N/2) * Fstep
	Fstep = 2*Fmax/N 
	Fstep = 1/ (N * Tstep)
	Tstep = 1/ (N*Fstep)

	
	*/
	public static Tstep(N:number, Fstep:number):number{
		return 1/ (N*Fstep);
	}
	public static Fstep(N:number, Tstep:number):number{
		return 1/ (N*Tstep);
	}	
    public static outOfBand(Fc_local:number, Fstep_local:number, N_local:number, 
        Fc_global:number, Fstep_global:number, N_global:number):boolean{
			
		let fMinGlobal = Fc_global + this.fftI2F_ifo( 0, N_global, Fstep_global  );
		let fMaxGlobal = Fc_global + this.fftI2F_ifo( (N_global-1), N_global, Fstep_global );
		let fMinLocal = Fc_local + this.fftI2F_ifo( 0, N_local, Fstep_local );
		let fMaxLocal = Fc_local + this.fftI2F_ifo( (N_local-1), N_local, Fstep_local );
		
		let oob:boolean = ( (fMinLocal>fMaxGlobal) || (fMaxLocal<fMinGlobal) );
		//console.log("fMinGlobal = "+fMinGlobal+", fMaxGlobal = "+fMaxGlobal+", fMinLocal = "+fMinLocal+", fMaxLocal = "+fMaxLocal+", oob = "+oob);
		return oob;
	}
	public static rescaleSpectrumW( localW:Waveform2, Fc_global:number, Fstep_global:number, N_global:number):Waveform2{
		//debugger;
		//console.log("Enteringing rescaleSpectrumW, Fc_global = :"+Fc_global)
		//localW.printWaveform();
		let S_local:Array<Complex> = localW.freqDomainComplex;
		let outputcaS:Array<Complex> = SigProc.rescaleSpectrum( S_local, 
			localW.Fc_global, localW.Fstep_global, localW.N_global,
			Fc_global, Fstep_global, N_global)
		let outputWaveform:Waveform2 = new Waveform2(N_global, Fc_global, Fstep_global);
		outputWaveform.freqDomainComplex = outputcaS;
		//console.log("in rescaleSpectrumW, outputWaveform:")
		//outputWaveform.printWaveform();
		//console.log("Returning from rescaleSpectrumW, outputWaveform.Fc_global = :"+outputWaveform.Fc_global)
		return outputWaveform;
	}
	public static rescaleSpectrum( S_local:Array<Complex>, 
		Fc_local:number, Fstep_local:number, N_local:number, 
		Fc_global:number, Fstep_global:number, N_global:number):Array<Complex>{
		/* Rescales a spectrum to new frequency step and center frequency.
		Inputs: S_local  input spectrum (array of complex)
				Fc_local input spectrum center freq
				Fstep_local  input spectrum frequency step
				N_local  input spectrum number of points
				
				Fc_global  desired output spectrum center freq
				Fstep_global  desired output spectrum frequency step
				N_global  desired output spectrum number of points
				
		Returns: scaled output spectrum (array of complex)
		
		Linearly interpolates re & im spectrum values in frequency domain.
		Normalizes whole spectrum for equal total power. ///NOT DONE
		
		*/
		let f_true:number;
		let f_local:number;
		let m_exact:number;
		let m1:number;
		let m2:number;
		let k:number;
		let r:number;
		let S_global:Array<Complex>;
		let Pin:number;
		let Pout:number;
		let sf:number
		let ii:number;
		
		if ( (Fc_local == Fc_global) && (Fstep_local == Fstep_global) && (N_local == N_global) ){
			console.log("In rescaleSpectrum, returning with no change")
			return S_local;  // No need to spend any extra effort!
		}
		//console.log("In SigProc.rescaleSpectrum");
		///debugger
		/*
		if (S_local instanceof Waveform1){
			// S_local is type Waveform1
			
			let sRe:number;
			let sIm:number;
			
			S_global = new Waveform1(N_global);
			//for (let ii=0; ii<N_global; ii++){
			//	S_global[ii] = new Complex(-123, -456);
			//}
											  
											  
			for (k= 0; k<N_global; k++){
				f_true = Fc_global + this.fftI2F_ifo( k, N_global, Fstep_global );
				f_local = f_true - Fc_local;
				m_exact = this.fftF2I_ifo( f_local, N_local, Fstep_local ); 
				//console.log("m_exact = "+m_exact+", f_local = "+f_local+", N_local = "+N_local+", Fstep_local = "+Fstep_local);
				if ( m_exact < 0){
					// Below bottom end of local signal
					sRe = 0;
					sIm = 0;
				} else if ( (m_exact >= 0) && (m_exact < (N_local-1)) ){
					// In range
					m1 = Math.floor(m_exact);
					m2 = m1+1;
					// Interpolate here
					r = (m_exact - m1)/(m2-m1);
					sRe = S_local.freqDomainRe[m1] + r * ( S_local.freqDomainRe[m2] - S_local.freqDomainRe[m1] );
					sIm = S_local.freqDomainIm[m1] + r * ( S_local.freqDomainIm[m2] - S_local.freqDomainIm[m1] );
					//console.log("Interp k = "+k+", m1 = "+m1+", r = "+r+", s.re = "+s.re+", S_local[m1].re = "+S_local[m1].re);
				} else if ( m_exact == (N_local-1) ){
					// Use the last value
					sRe = S_local.freqDomainRe[m_exact];
					sIm = S_local.freqDomainIm[m_exact];
				} else if ( m_exact > (N_local-1) ){
					// Above top end.  Set to zer.
					sRe = 0;
					sIm = 0;
				}
				S_global.freqDomainRe[k] = sRe;
				S_global.freqDomainIm[k] = sIm;
				//console.log("   k = "+k+", s.re = "+s.re +", S_global[k].re = "+S_global[k].re);
				if (isNaN(sRe) || isNaN(sIm) ){
					console.log("Error in SigProc.rescaleSpectrum: NaN found.");
				}
				//console.log("      S_global[512].re = "+S_global[kk].re);
			}
			S_global.freqDomainIValid = true;
			S_global.freqDomainQValid = true;
			S_global.Fc = Fc_global;
			S_global.Fstep = Fstep_global;
			
			//console.log("S512 (before return) = "+ S_global[512].re);
			// Now normalize the output spectrum so it has the same total power as the input spectrum.
			// But if the output spectrum is outside the window, the power and the re/im components will be zero.
			Pin = this.totalPowerW( S_local, 50);
			Pout = this.totalPowerW( S_global, 50);
			if (isNaN(Pin) || isNaN(Pout) ){
				console.log("Error in SigProc.rescaleSpectrum: NaN found.");
			}
			if (Pout > 0){
				sf = Math.sqrt(Pin/Pout);
				//console.log("sf = "+sf);
				for (k= 0; k<N_global; k++){
					S_global.freqDomainRe[k] *= sf;
					S_global.freqDomainIm[k] *= sf;
				}
			}
			return S_global; // instance of Waveform1			
		} else {
			*/
			// S_local is array of Complex
			let s1:Complex = new Complex();
			let s2:Complex = new Complex();
			let s:Complex = new Complex();
			
			S_global = new Array(N_global);
			for (ii=0; ii<N_global; ii++){
				S_global[ii] = new Complex(-123, -456);
			}
											  
			//console.log("In rescaleSpectrum, Fstep_global = "+Fstep_global+", Fstep_local = "+Fstep_local);					  
			for (k= 0; k<N_global; k++){
				f_true =  this.i2f( k, N_global, Fc_global, Fstep_global );
				//f_local = f_true - Fc_local;
				m_exact = this.f2i( f_true, N_local, Fc_local, Fstep_local ); // Float
				// console.log("k = "+k+", N_global = "+N_global+", Fstep_global = "+Fstep_global+
				// 	", Fc_global = "+Fc_global+", f_true = "+f_true+
				// 	", N_local = "+N_local+", Fstep_local = "+Fstep_local+", m_exact = "+m_exact);
				//console.log("m_exact = "+m_exact+", f_local = "+f_local+", N_local = "+N_local+", Fstep_local = "+Fstep_local);
				if ( m_exact < 0){
					// Below bottom end of local signal
					s.re = 0;
					s.im = 0;
					//console.log("m_exact is Below bottom end of local signal");
				} else if ( (m_exact >= 0) && (m_exact < (N_local-1)) ){
					// In range
					m1 = Math.floor(m_exact);
					m2 = m1+1;
					// Interpolate here
					r = (m_exact - m1)/(m2-m1);
					s.re = S_local[m1].re + r * ( S_local[m2].re - S_local[m1].re );
					s.im = S_local[m1].im + r * ( S_local[m2].im - S_local[m1].im );
					//console.log("Interp k = "+k+", m1 = "+m1+", r = "+r+", s.re = "+s.re+", S_local[m1].re = "+S_local[m1].re);
				} else if ( m_exact == (N_local-1) ){
					// Use the last value
					s.re = S_local[m_exact].re;
					s.im = S_local[m_exact].im;
					//console.log("m_exact == (N_local-1");
				} else if ( m_exact > (N_local-1) ){
					// Above top end.  Set to zero.
					s.re = 0;
					s.im = 0;
					//console.log("m_exact is Above top end of local signal");
				}
				S_global[k].re = s.re;
				S_global[k].im = s.im;
				//console.log("In SigProc.rescaleSpectrum,  k = "+k+", s.re = "+s.re +", S_global[k].re = "+S_global[k].re);
				if (isNaN(s.re) || isNaN(s.im) ){
					console.log("Error in SigProc.rescaleSpectrum: NaN found.");
				}
			}
			//console.log("S512 (before return) = "+ S_global[512].re);
			// Now normalize the output spectrum so it has the same total power as the input spectrum.
			// But if the output spectrum instanceof outside the window, the power and the re/im components will be zero.
			Pin = this.totalPowerW( S_local, 50);
			Pout = this.totalPowerW( S_global, 50);
			//console.log("In SigProc.rescaleSpectrum,  Pin = "+Pin+", Pout = "+Pout);
			if (isNaN(Pin) || isNaN(Pout) ){
				console.log("Error in SigProc.rescaleSpectrum: NaN found.");
			}
			if (Pout > 0){
				sf = Math.sqrt(Pin/Pout);
				//console.log("sf = "+sf);
				S_global = Complex.mulCA( S_global, sf);
			}
			//debugger
			return S_global;
		//}
	}
										   
	public static fftConstantPowerW1(input:Waveform1):Waveform1{
		/* Returns the fwd FFT 
		Input must be type Waveform1 array
		If length of input array is not a power of two, it increases the array size to
		a power of two and pads the remaining cells with zeros.
		Scales by N so that total output power (both sides of spectrum) = average input power
		*/
		let M:number;
		let N2:number;
		let x:Array<number>;
		let y:Array<number>;
		let i:number;

		//console.log("Assume input is type Waveform1.");
		M = input.timeDomainRe.length;
		N2 = this.nextMul( M );
		let output:Waveform1 = new Waveform1(N2);
		x = new Array<number>(N2);
		y = new Array<number>(N2);
		for (i = 0; i<M; i++){
			x[i] = input.timeDomainRe[i];
			y[i] = input.timeDomainIm[i];
		}
		if (M < N2){
			for (i = M; i<N2; i++){
				x[i] = 0; y[i] = 0;
			}
		}
		this.fftCore( x, y, false ); // Does an FFT in place
		
		for (i = 0; i<N2; i++){
			output.freqDomainRe[i] = x[i]/N2;
			output.freqDomainIm[i] = y[i]/N2;
		}
		return output;

	}								   
	public static fftConstantPowerAC(input:Array<Complex>):Array<Complex>{
		/* Returns the fwd FFT 
		Input must be type Complex Array
		If length of input array is not a power of two, it increases the array size to
		a power of two and pads the remaining cells with zeros.
		Scales by N so that total output power (both sides of spectrum) = average input power
		*/
		let M:number;
		let N2:number;
		let x:Array<number>;
		let y:Array<number>;
		let i:number;	

		M = input.length;
		N2 = this.nextMul( M );
		x = new Array(N2);
		y = new Array(N2);
		let output:Array<Complex> = new Array(N2);
		
		for (i = 0; i<M; i++){
			x[i] = input[i].re;
			y[i] = input[i].im;
		}
		if (M < N2){
			for (i = M; i<N2; i++){
				x[i] = 0; y[i] = 0;
			}
		}
		this.fftCore( x, y, false );
		//console.log(x);
		//console.log(y);
		for (i = 0; i<N2; i++){
			output[i] = Complex.make( x[i]/N2, y[i]/N2 );
		}
		return output; //array of complex values.
	}
	
	public static fft(input:any):any{
		/* Returns the fwd FFT 
		Input must be type Waveform1 or Complex array
		If length of input array is not a power of two, it increases the array size to
		a power of two and pads the remaining cells with zeros.
		Scales by N so that total output power (both sides of spectrum) = average input power
		*/
		let M:number;
		let N2:number;
		let x:Array<number>;
		let y:Array<number>;
		let i:number;
		if (input instanceof Waveform1){
			//console.log("Assume input is type Waveform1.");
			M = input.timeDomainRe.length;
			N2 = this.nextMul( M );
			let output:Waveform1 = new Waveform1(N2);
			x = new Array<number>(N2);
			y = new Array<number>(N2);
			for (i = 0; i<M; i++){
				x[i] = input.timeDomainRe[i];
				y[i] = input.timeDomainIm[i];
			}
			if (M < N2){
				for (i = M; i<N2; i++){
					x[i] = 0; y[i] = 0;
				}
			}
			this.fftCore( x, y, false ); // Does an FFT in place
			
			for (i = 0; i<N2; i++){
				output.freqDomainRe[i] = x[i]/N2;
				output.freqDomainIm[i] = y[i]/N2;
			}
			return output;
		} else if (input instanceof Array){
			// Assume input is an array of Complex
			//console.log("Assume input is an array of Complex.");
			M = input.length;
			N2 = this.nextMul( M );
			x = new Array(N2);
			y = new Array(N2);
			let ans:Array<Complex> = new Array(N2);
			
			for (i = 0; i<M; i++){
				x[i] = input[i].re;
				y[i] = input[i].im;
			}
			if (M < N2){
				for (i = M; i<N2; i++){
					x[i] = 0; y[i] = 0;
				}
			}
			this.fftCore( x, y, false );
			//console.log(x);
			//console.log(y);
			for (i = 0; i<N2; i++){
				ans[i] = Complex.make( x[i]/N2, y[i]/N2 );
			}
			return ans; //array of complex values.
		}
	}

	public static ifftConstantPowerAC(ca_z:Array<Complex>):Array<Complex>{
		/* Returns the inverse FFT as an array of complex values.
		Input value is an array of complex values.
		If length of input array instanceof not a power of two, it increases the array size to
		a power of two and pads the remaining cells with zeros.
		Scales by N so that total input power (both sides of spectrum) = average output power
		*/
		
		let M = ca_z.length;
		let N2 = this.nextMul( M );
		let x:Array<number> = new Array(N2);
		let y:Array<number> = new Array(N2);
		let ans:Array<Complex> = new Array(N2);
		let i:number;
		
		for (i = 0; i<M; i++){
			x[i] = ca_z[i].re;
			y[i] = ca_z[i].im;
		}
		if (M < N2){
			for (i = M; i<N2; i++){
				x[i] = 0; y[i] = 0;
			}
		}
		this.fftCore( x, y, true );
		//console.log(x);
		//console.log(y);
		for (i = 0; i<N2; i++){
			ans[i] = Complex.make( x[i]*N2, y[i]*N2 );
		}
		return ans;
	}

   public static fftCore( x:Array<number>, y:Array<number>, inv:boolean ) {
   /**
	x and y must be Array or Vector
   Translated from the file accompanying Java for Scientists and Engineers and Introduction to Java, both by Stephen J Chapman
   
    * This method is the computational core of the forward and
    * inverse Fast Fourier Transforms.  This method destroys its
    * input data.  The method assumes that the length of the data
    * passed to it is a power of two, and that arrays x and
    * y have equal length.  These facts must be verified before
    * calling the method.
    * Parameters:
    *    x   The input real values.
    *    y   The input imaginary values values.
    *    inv Forward/inverse flag: true = inverse
    * Returns:
	*    The FFT/inverse FFT of (x,y).
    */

      // Declare variables and arrays
      let a:number;                        // angle in radians
      let cosa:number, sina:number;               // cos(a), sin(a)
      let e:number;                        // Angular step size
      let exp:number = 0;                     // (int) Power of 2
      let i:number, j:number, k:number, l:number, n1:number, n2:number;          // (int) Loop indices
      let m:number = 2;                       // (int) 2^exp
      let n:number = x.length;                // (int) Array length
      let xt:number;                       // swap variable
      let yt:number;                       // swap variable

      // Work out the power of 2 that is >= the array length
      do {
         exp = exp + 1;
         m   = 2 * m;
      } while ( m < x.length );

      // Main FFT Loops
      n2 = n;
      for ( k = 1; k <= m; k++ ) {
         n1 = n2;
         n2 = n2 / 2;
         e = 2*Math.PI / n1;
         a = 0;
         for ( j = 1; j <= n2; j++ ) {
          if ( inv ) {
            // Inverse FFT
               cosa =  Math.cos( a );
               sina =  Math.sin( a );
         } else {
            // Forward FFT
               cosa =  Math.cos( a );
               sina = -Math.sin( a );
         }
            a = j * e;
            for ( i = j; i <= n; i+=n1 ) {
               l      = i + n2;
               xt     = x[i-1] - x[l-1];
               x[i-1] = x[i-1] + x[l-1];
               yt     = y[i-1] - y[l-1];
               y[i-1] = y[i-1] + y[l-1];
               x[l-1] = xt*cosa - yt*sina;
               y[l-1] = xt*sina + yt*cosa;
            }
         }
      }

      // Digit reverse counter
      j = 1;
      n1 = n - 1;
      for ( i = 1; i <= n1; i++ ) {
         if ( i < j ) {
            xt     = x[j-1];
            x[j-1] = x[i-1];
            yt     = y[j-1];
            y[j-1] = y[i-1];
            x[i-1] = xt;
            y[i-1] = yt;
         }
         k = n / 2;
         while ( k < j ) {
            j = j - k;
            k = k / 2;
         }
         j = j + k;
      }

      // Divide by array size for inverse FFT
      if ( inv ) {
         for ( i = 0; i < n; i++ ) {
            x[i] = x[i] / n;
            y[i] = y[i] / n;
         }
      }
   }
   public static fftSwapAN(input:Array<number>):Array<number>{
		/*
		Shifts the output of an FFT so that the dc component appears in the middle of the spectrum.
		Returns the array with the upper and lower halves of input swapped.
		Input is an array of numbers.
		*/
		let len:number = input.length;
		let d1:Array<number> = new Array(len);// Create output array
		let mid:number = Math.floor(len / 2);
		// Swap the data
		let k:number = 0;
		let i:number;
		for ( i = mid+1; i < len; i++ ) {
			d1[k++] = input[i];
		}
		for ( i = 0; i < mid+1; i++ ) {
			d1[k++] = input[i];
		}
		return (d1);
   }
   public static fftInverseSwapAN(input:Array<number>):Array<number>{
		/* Shifts a spectrum which is in frequency order back to FFT order.
		See "FFT Essentials.xls" for explanation of indices.
		*/
		let len:number = input.length;
		let d1:Array<number> = new Array(len);// Create output array
		let mid:number = Math.floor(len / 2);
		// Swap the data
		let k:number = 0;
		let i:number;
		let j:number;
		for (k=0; k<len; k++){
			if (k <= (mid-2) ){
				j = k + mid + 1;
			} else {
				j = k - mid + 1;
			}
			d1[j] = input[k];
		}
		return (d1);
	}
	public static fftInverseSwapAC(input:Array<Complex>):Array<Complex>{
		/* Shifts a spectrum which is in frequency order back to FFT order.
		See "FFT Essentials.xls" for explanation of indices.
		*/
		let len:number = input.length;
		let d1:Array<Complex> = new Array(len);// Create output array
		let mid:number = Math.floor(len / 2);
		// Swap the data
		let k:number = 0;
		let i:number;
		let j:number;
		for (k=0; k<len; k++){
			if (k <= (mid-2) ){
				j = k + mid + 1;
			} else {
				j = k - mid + 1;
			}
			d1[j] = input[k];
		}
		return (d1);
	}

   public static fftSwapAC(input:Array<Complex>):Array<Complex>{
		/*
		Shifts the output of an FFT so that the dc component appears in the middle of the spectrum.
		Returns the array with the upper and lower halves of input swapped.
		*/
		
		let len:number = input.length;
		let d1:Array<Complex> = new Array(len);// Create output array
		let mid:number = Math.floor(len / 2);
		// Swap the data
		let k:number = 0;
		let i:number;
		for ( i = mid+1; i < len; i++ ) {
			d1[k++] = input[i];
		}
		for ( i = 0; i < mid+1; i++ ) {
			d1[k++] = input[i];
		}

		// Return the swapped array
		return (d1);
	}  


   public static fftSwap( input:any ):any {
   /**
    * This method shifts the output of an FFT so that the dc component appears
    * in the middle of the spectrum.
    * Input:   
	*    d The input array.
    * Returns:
	*     The array with the upper and lower halves of d swapped.
    */

		let i:number, k:number, mid:number;
		let len:number;
		if (input instanceof Waveform1){
			// Create output Waveform1
			//console.log("In fftSwap, input re = "+input.freqDomainRe);
			len = input.freqDomainRe.length;
			mid = len / 2;
			let output:Waveform1 = new Waveform1(len);
			// Swap the data
			k = 0;
			for ( i = mid+1; i < len; i++ ) {
				output.freqDomainRe[k] = input.freqDomainRe[i];
				output.freqDomainIm[k] = input.freqDomainIm[i];
				k++;
			}
			for ( i = 0; i < mid+1; i++ ) {
				output.freqDomainRe[k] = input.freqDomainRe[i];
				output.freqDomainIm[k] = input.freqDomainIm[i];
				k++;
			}
			//console.log("In fftSwap, output re = "+output.freqDomainRe);
			return (output);
			
		} else if (input instanceof Array){

			// Create output array
			let d1:Array<Complex> = new Array(input.length);
			len = input.length;
			mid = len / 2;
			// Swap the data
			k = 0;
			for ( i = mid+1; i < input.length; i++ ) {
				d1[k++] = input[i];
			}
			for ( i = 0; i < mid+1; i++ ) {
				d1[k++] = input[i];
			}

			// Return the swapped array
			return (d1);
		} else {
            console.log("ERROR in SigProc.fftSwap - invalid input type. Musbe be either Waveform1 or Complex Array");
            /*
			// Create output vector
 			// Create output array
			len = input.length;
			let vecOut:Vector.<number> = new Vector.<number>(len, true);
			mid = len / 2;
			// Swap the data
			k = 0;
			for ( i = mid+1; i < input.length; i++ ) {
				vecOut[k++] = input[i];
			}
			for ( i = 0; i < mid+1; i++ ) {
				vecOut[k++] = input[i];
			}

			// Return the swapped array
            return (vecOut);
            */
		}
  }
   public static fftInverseSwap( d ) {
	/* Shifts a spectrum which is in frequency order back to FFT order.
	See "FFT Essentials.xls" for explanation of indices.
	*/
		let k:number; // Index of spectrum in freq order
		let j:number; // Index of spectrum in FFT order
		let N:number;
		
		N = d.length;
		if (d instanceof Array){
			// Create output array
			let d1:Array<Complex> = new Array(N);
	  
			for (k=0; k<N; k++){
				if (k <= (N/2-2) ){
					j = k + N/2 + 1;
				} else {
					j = k - N/2 + 1;
				}
				d1[j] = d[k];
			}
			return (d1);
		} else {
            console.log("ERROR in SigProc.fftSwap - invalid input type. Muste be either Waveform1 or Complex Array");
            /* ////
            // d is vector
			// Create output vector
			let vecOut:Vector.<number> = new Vector.<number>(N, true);
	  
			for (k=0; k<N; k++){
				if (k <= (N/2-2) ){
					j = k + N/2 + 1;
				} else {
					j = k - N/2 + 1;
				}
				vecOut[j] = d[k];
			}
			return (vecOut);
			*/
		}
   }
   
   public static nextMul( arraySize:number ):number {
    /**
    * This method calculates the power of two greater than or equal to
    * a given input size.
    *
    * @param   size     The input size
    * @return  an <code>int</code> containing the required power of two.
    */

      // Check for a valid size
      let exp:number = 0;         // Power of 2
      let m:number = 2;           // 2^exp

      // Work out the power of 2 that is >= the array length
      do {
         exp = exp + 1;
         m   = 2 * m;
      } while ( m < arraySize );

     return m;
   }

    public static calcFreq( fs:number, fftSize:number ):Array<number> {
/**
    * This method calculates the frequency associated with each element of the
    * output array from an FFT, taking into account the ambiguities above the
    * Nyquist frequency.
    *
    * @param   fs  The sampling frequency of the input data to the FFT
    * @param   fftSize  The size of the FFT.
    * @return  an array containing the frequency of each bin (element) in
    *          the output from the FFT.
    */

      // Calculate df
      let df:number = fs / fftSize;    // Frequency step size

      // Initialize output array
      let fArray:Array<number> = new Array(fftSize);

      // Calculate frequency step
      fArray[0] = 0;
      fArray[fftSize/2] = fs/2;
      for ( let i = 1; i < fftSize/2; i++ ) {
         fArray[i] = i*df;
         fArray[fftSize-i] = -i*df;
      }

      return fArray;
   }

	
	
    public static fftI2F_fto( j:number, N:number, fs:number ):number {
		// Returns the frequency of a given index in FFT order
		if (j <= N/2 ){
			return j * fs;
		}else{
			return fs * ( j - N);
		}
	}
	
    public static fftF2I_fto( f:number, N:number, fs:number ):number {
		// Returns the index of a given frequency in FFT order
		let fmax = fs * N/2;
		if (f >= 0 ){
			return f / fs;
		}else{
			return f/fs + N;
		}
	}
		
    public static fftI2F_ifo( k:number, N:number, fs:number ):number {
		// Returns the frequency of a given index in increasing freq order
		return fs*( -N/2 +1 + k);
	}
	
    public static fftF2I_ifo( f:number, N:number, fs:number ):number {
		// Returns the index of a given frequency in increasing freq order
		return f/fs + N/2 - 1;
	}
	public static listSpectrum_ifo( S, fs ){
		let N = S.length;
		for (let k=0;k<N;k++){
			let f = SigProc.fftI2F_ifo(k,N,fs);
			console.log( " f = "+ f +  ", S["+k+"] = "+ Complex.toString(S[k]) );
		}

	}
	public static f2i(f:number, N:number, fcenter:number, fstep:number):number{
		// Converts frequency to spectrum index. Assumes increasing frequency order.
		let i:number =  (f - fcenter)/fstep + (N-1)/2;
		return i;
	}
	public static i2f(i:number, N:number, fcenter:number, fstep:number):number{
		// Converts spectrum index to frequency. Assumes increasing frequency order.
		let f:number =  fcenter + fstep*( i - (N-1)/2);
		return f;
	}
	public static totalPowerW( S, Z0){
		let vsq_pcum = 0;
		let i:number;
		if (S instanceof Waveform1){
			for (i=0; i<S.freqDomainRe.length; i++){
				vsq_pcum += S.freqDomainRe[i] * S.freqDomainRe[i] + S.freqDomainIm[i] * S.freqDomainIm[i];
			}
		} else {
			// Assume S is array of complex
			for (i=0; i<S.length; i++){
				vsq_pcum += S[i].re * S[i].re + S[i].im * S[i].im;
			}
		}
		return vsq_pcum/Z0;
	}
	public static applyGaindB(S, gaindB){
		// Scales complex array S by gain
		let f = UtilSP.dB2Vratio(gaindB);
		
	}



} // End class